import { Injectable } from "@angular/core";
import { BulkUpdateContactDto } from "@models/billing-signing/bulk-update-contact-dto";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RelationshipsApiService extends BaseApiService {
  setRelationshipsContacts(request: BulkUpdateContactDto): Observable<void> {
    return this.api.put<void>(`${ this.apiUrl }/relationships/contact/bulk`, request);
  }
}
